module.exports = __webpack_public_path__ + "img/carousel-pagination-notactive.5f5822b5.svg";